export default __webpack_public_path__ + "static/media/sanaType1.120974d5.PNG";